/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgUnderline = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M1011 1792q-161 0-274-46t-184-133-105-209-33-275V128h192v988q0 109 21 201t71 159 131 106 201 38q115 0 193-36t127-101 69-154 21-195V128h192v975q0 158-34 285t-109 217-193 138-286 49zm-627 128h1280v128H384v-128z"
    }));
export default SvgUnderline;
